import React, { Component } from 'react';

import ResourceCard from '../Module/MyResourceCard';

import DetailView from '../Common/DetailView';

import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import SkillIcon from 'material-ui/svg-icons/social/public';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import ActivityIcon from 'material-ui/svg-icons/action/timeline';
import ComplianceIcon from 'material-ui/svg-icons/action/done-all';
import ModuleIcon from 'material-ui/svg-icons/action/view-module';


import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleStore from '../../stores/ModuleStore';

import buildContextMenu from '../Common/BuildContextMenu';

class MyResourceList extends Component {

    constructor() {
        super(...arguments);

        this.state = {
            actions: buildContextMenu(this.getActions()),
            resources: [],
            sortCriteria: null,
            sortMapCriteria: null,
        };
    }

    getActions() {
        return [
            {
                link: '/dashboard/mytraining',
                icon: <SchoolIcon />,
                label: 'My training',
            },
            {
                link: '/dashboard/mytraining/compliance',
                icon: <ComplianceIcon />,
                label: 'My compliance',
            },
            {
                link: '/dashboard/mytraining/skills',
                icon: <SkillIcon />,
                label: 'My skills',
            },
            {
                link: '/dashboard/mytraining/courses',
                icon: <SchoolIcon />,
                label: 'My courses',
            },
            {
                link: '/dashboard/mytraining/modules',
                icon: <ModuleIcon />,
                label: 'My modules',
            },
            {
                link: '/dashboard/mytraining/resources',
                icon: <LibraryIcon />,
                label: 'My resources',
            },
            {
                link: '/dashboard/mytraining/activities',
                icon: <ActivityIcon />,
                label: 'My Activities',
            },
            {
                type:'divider'
            },
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            },
        ];
    }

    componentDidMount() {
        this.onModuleChange = this.onModuleChange.bind(this);
        this.sort = this.sort.bind(this);
        this.moduleListener = ModuleStore.addListener(this.onModuleChange);
        ModuleActions.getMyResources();
    }

    componentWillUnmount() {
        this.moduleListener.remove();
    }

    render() {

        let resources;
        if (this.state.resources.length) {
            let resourceList = this.state.resources.map( (resource) => (
                <ResourceCard {...resource} key={resource.id}/>
            ));
            resources = (
                <div className="cent-cards">
                    {resourceList}
                </div>
            );
        }

        return (
            <DetailView
                title="My resources"
                actions={this.state.actions}
            >
                {resources}
            </DetailView>
        )
    }

    onModuleChange() {
        const resources = ModuleStore.getMyResources();
        if (!!resources) {
            if (resources.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                this.setState({resources});
            } else {
                const mapped = resources.map(this.state.sortMapCriteria);
                mapped.sort(this.state.sortCriteria);
                const sortedResources = mapped.map((el) => resources[el.index]);
                this.setState({resources: sortedResources});
            }
        }
    }

    sort(options) {
        let sortCriteria, sortMapCriteria;
        switch (options.sort) {
            case 'name':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.name});
                break;
            case 'code':
                sortCriteria = (a, b) => !a.value ? 1 : a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.code});
                break;
            case 'dateAdded':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.dateAdded)});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[this.state.sort]});
        }
        this.setState({sort: options.sort, sortCriteria, sortMapCriteria});
        ModuleActions.getMyResources({sort: options.sort});
    }

}

MyResourceList.defaultProps = {
    sortOptions: [
        {label: "Name", value: 'name'},
        {label: "Code", value: 'code'},
        {label: "Created", value: 'dateAdded'}
    ]
};


export default MyResourceList;
